<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main  animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
      <ViewDashboard v-if="!hasPermissions('adminClients')"></ViewDashboard>
      <DashboardAdmin v-else></DashboardAdmin>
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import ViewDashboard from "@/components/Dashboard/ViewDashboard.vue";
import DashboardAdmin from "@/components/Dashboard/DashboardAdmin.vue";
import ToastNotifications from "@/components/ToastNotifications.vue";
import {
  adminService
} from "@/_services";


export default {

  data(){
    return{
        pmethods:[],
        loading:true
    }
  },
   mounted(){
    //window.onbeforeunload  = null;   

    if (this.$route.query.code) {
      let code = this.$route.query.code;
      adminService.sendCodeGoogle(code).then((res) => {
        if (res && res.warning == "ms_personal_account") {
          this.$swal({
            type: "warning",
            title: "Microsoft",
            text: this.$t("lang.appointments.ms_personal_account"),
            showConfirmButton: true,
          });
        } else if (res) {
          this.$swal({
            type: "success",
            title: "success",
            text: "account synced successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }

    this.setDashboardHeader();
  },

  watch: {
    "$route.params.tab"() {
      this.setDashboardHeader();
    },
  },

  created() {
    this.changeHeaderTab({ tab: "ALL" });
    if (typeof this.$route.params.id !== "undefined") {
      this.changeHeaderTab({ tab: "SELECTED" });
    }
  },

  components: {
    ToastNotifications,
    ViewDashboard,
    DashboardAdmin
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,

      paymentMethods: state => state.billings.all
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    setDashboardHeader() {
      const tab = this.$route.params.tab;
      if (tab === "8") {
        this.setCurrentRoute({ page: "meetings" });
        this.setCurrentRouteChild({ child: "" });
      } 
      else if (tab === "1") {
        this.setCurrentRoute({ page: "statistics" });
        this.setCurrentRouteChild({ child: "" });
      } 
      else if (tab === "3") {
        this.setCurrentRoute({ page: "workspaces" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "10") {
        this.setCurrentRoute({ page: "queue-emails" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "19") {
        this.setCurrentRoute({ page: "business-contacts" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "22") {
        this.setCurrentRoute({ page: "meetings-dispertion" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "21") {
        this.setCurrentRoute({ page: "metrics" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "24") {
        this.setCurrentRoute({ page: "operators" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "28") {
        this.setCurrentRoute({ page: "phone_directory" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "11") {
        this.setCurrentRoute({ page: "mailboxes" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "29") {
        this.setCurrentRoute({ page: "revenue-client-report" });
        this.setCurrentRouteChild({ child: "" });
      }
      else if (tab === "14") {
        this.setCurrentRoute({ page: "credits" });
        this.setCurrentRouteChild({ child: "" });
      }
      else {
        this.setCurrentRoute({ page: this.$route.name });
        this.setCurrentRouteChild({ child: "" });
      }
    },
  }
};
</script>
